import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { LDFlagsService } from '@degreed/lxp/services';
import { AuthService } from '@degreed/lxp/services/authorization';

export function flexiblePlansGuard(): boolean | UrlTree {
  if (inject(LDFlagsService).flexiblePage) return true;
  const vanityUrl =
    inject(AuthService).authUser?.viewerProfile?.vanityUrl ?? '';
  return inject(Router).parseUrl(`/${vanityUrl}/home/overview`);
}
